import ListItem from "../../components/ListItem";
import BottomButtonWrapper from "../../components/BottomButtonWrapper";
import Button from "../../components/newComponents/button/Button";
import {useNavigate, useSearchParams} from "react-router-dom";
import moment from "jalali-moment";
import BillTypes from "../../tools/defaults/billTypes";
import HeaderCard from "../../components/tosan/HeaderCard";
import React from 'react';
import html2canvas from 'html2canvas';
import {toFarsiNumber} from "../../tools/helpers";
const PaymentReceipt = () => {

    const navigate = useNavigate()
    const [searchParams] = useSearchParams();
    const rrn = searchParams.get('rrn')
    const date = +searchParams.get('date') * 1000;
    const price = searchParams.get('price')
    const persianDate = moment(date).format('jYYYY/jM/jD HH:mm:ss');
    const tracingNumber = searchParams.get('date');
    const billType = searchParams.get('billType')
    const parameter = searchParams.get('parameter')
    const billId = searchParams.get('billId');
    const payId = searchParams.get('payId');

    const captureAndDownload = () => {
        const element = document.getElementById('receipt');
        html2canvas(element).then((canvas) => {
            const imgData = canvas.toDataURL('image/png');
            const link = document.createElement('a');
            link.href = imgData;
            link.download = 'div_image.png';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    }
    const handleNavigate = () => {
        navigate('/tosan/')
    }
    return <div>
        <HeaderCard hasBack={false} onBack={handleNavigate}
                    className="flex  justify-center default-header-card flex-col items-center ">
            <h1 className="text-lg title">جزییات پرداخت</h1>
        </HeaderCard>
        <div id="receipt" className="mx-auto px-3 py-6   lg:w-6/12 mb-28 xl:w-4/12    ">


            <div className="grid grid-cols-1 border rounded-lg overflow-hidden">
                <div className="py-3 px-5 flex rounded-t-lg bg-green-200 justify-center items-center  "><p className="text-success">قبض
                    با موفقیت پرداخت شد.</p></div>
                <ListItem title={"نوع قبض"}
                          value={BillTypes[billType]?.receipt_title}/>
                {billType && BillTypes[billType] && <ListItem title={BillTypes[billType].inputLabel}
                                                              value={toFarsiNumber(parameter)}/>}

                {/*       <ListItem title={"شناسه قبض"}
                          value={billId}/>
                <ListItem title={"شناسه پرداخت"}
                          value={payId}/>*/}

                <ListItem isPrice={true} title={"مبلغ پرداختی"}
                          value={price}/>
                <ListItem title={"تاریخ پرداخت"}
                          value={toFarsiNumber(persianDate)}/>
                <ListItem title={"شماره مرجع"}
                          value={toFarsiNumber(rrn)}/>
                <ListItem title={"شماره پیگیری"}
                          value={toFarsiNumber(tracingNumber)}/>


            </div>
        </div>
        <BottomButtonWrapper grid={2}>
            <Button outlined={false} onClick={handleNavigate} rounded="rounded-lg" theme="link">بازگشت</Button>
            <Button outlined={false} onClick={captureAndDownload} rounded="rounded-lg" theme="primary">دریافت رسید</Button>
        </BottomButtonWrapper>

    </div>
}
export default PaymentReceipt;